import { logger } from '@/utils/logger';
import { env } from '@zopauk/nextjs-env';
import { staticTheme } from '@/utils/theme';
import axios, { type AxiosInstance } from 'axios';
import { correlationInterceptor, loggerInterceptor, csrfInterceptor } from '@zopauk/libs-axios';

let appInstance: AxiosInstance;

const isDev = env('NEXT_PUBLIC_APP_ENV') === 'development';

/**
 * Set the quopa API axios instance
 *
 * @returns AxiosInstance
 */
const initAppInstance = () => {
  appInstance = axios.create({
    withCredentials: true,
    baseURL: `${staticTheme().basePath}/api`,
  });

  csrfInterceptor({ instance: appInstance });
  correlationInterceptor({ instance: appInstance });
  loggerInterceptor({
    identifier: 'CLIENT API',
    instance: appInstance,
    verbose: isDev,
    logger,
  });

  return appInstance;
};

export const getAppInstance = () => appInstance || initAppInstance();
